import axios from 'axios'
import { falconHost } from '../config/env.conf'

export const falconReport = function({ metric, tags, statusIgnored, counterType }) {
    let matchRes = tags.match(/status=(\d+)/);
    let status = matchRes && Number(matchRes[1]);
    if (Array.isArray(statusIgnored) && statusIgnored.indexOf(status) > -1) {
        console.info(`falcon信息:status ${status} 过滤掉不上报`);
        return;
    }

    let data = {
        metric: metric,
        tags: tags || '',
        counterType: counterType || 'INCREMENT'
    };
    _handle(data);
}

function _handle(data) {
    axios.post(falconHost, data);
}


// WEBPACK FOOTER //
// ./src/utils/falconReport.js